import {Box, Stack, styled} from '@mui/material';

const IconContainer = styled(Box)`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 56px;
	height: 56px;
	border-radius: 50%;
	background-color: ${({theme}) => theme.palette.warning.light}20;
	align-self: center;
	margin-bottom: ${({theme}) => theme.spacing(1)};
`;

const ContactBox = styled(Box)`
	background-color: ${({theme}) => theme.palette.action.hover};
	border-radius: ${({theme}) => theme.shape.borderRadius}px;
	padding: ${({theme}) => theme.spacing(2)};
`;

const ContactItem = styled(Stack)`
	flex-direction: column;
	gap: 2px;
`;

const ContactLink = styled('a')`
	color: ${({theme}) => theme.palette.primary.main};
	text-decoration: none;
	font-size: 1rem;

	&:hover {
		text-decoration: underline;
	}
`;

export {IconContainer, ContactBox, ContactItem, ContactLink};
